import { DataBean } from "../DataBean";

export class ImpOfficeNew extends DataBean {

    public async importOfficeCatalog(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_importOfficeCatalog_String_String_String", [filename, directory, dataStore]);
    }

}